import React, { Component } from 'react';
import HttpService from '../../util/HttpService';
import * as LocalStorageManager from '../../util/StorageManager';
import { parseDecimal, decimalFormat, isDefined } from '../../util/Common';
import { Label, Icon, Popup, Checkbox, Segment, Button, Header, Modal } from 'semantic-ui-react';
import { If } from '../../components/ConditionalRendering';
import ReactTable from 'react-table';
import { toast } from 'react-toastify';
import _ from 'lodash';

import 'react-table/react-table.css';

class ModalProdutos extends Component {

    constructor(props){
        super(props);

        this.state = {
            produtos: [],
            adicionandoProdutos: false,
            isLoading: false
        }
    }

    abrirModalProdutos = () => {
        this.setState({ adicionandoProdutos: true });
        this.buscarProdutos();
    }

    buscarProdutos = () => {
        this.setState({ isLoading: true });

		HttpService.call(
            'cadastro/orcamentoVenda',
			'buscarProdutos',
			[
                this.props.cliente,
                LocalStorageManager.getOrigem().idt
			],
			(produtos) => {
                // Altera os produtos que ja existem no pedido
                produtos = _.map(produtos, produto => {
                    const novoProduto = _.find(this.props.produtos, item => item.codigo === produto.codigo);

                    if(isDefined(novoProduto)){
                        // Pega o limite de desconto da lista completa de produtos, pois eh um dado que vem da tabela de preco
                        novoProduto.limiteDesconto = produto.limiteDesconto;

                        return novoProduto;
                    }

                    return produto;
                });

                this.setState({ produtos, isLoading: false });
            }
        );
    }

	salvarProdutos = () => {
        const produtos = _.filter(this.state.produtos, item => parseDecimal(item.quantidade, 3) > 0);
        this.props.onChange(produtos);
        this.setState({ adicionandoProdutos : false });
        toast.success('Produtos alterados com sucesso!');
    }
    
    calcularValorTotalProduto = (index) => {
        const { produtos } = this.state;
        const produto = produtos[index];

        const unitario = parseDecimal(produto['valorUnitario'], 2);
        const quantidade = parseDecimal(produto['quantidade'], 3);

        const valorTotal = quantidade * unitario;
        
        produto['valorTotal'] = valorTotal.toFixed(2);

        this.setState({ produtos });
    }

    selectText = ({ target }) => target.select();

    render(){
        const { produtos, adicionandoProdutos, isLoading } = this.state;
        const { disabled } = this.props;

        const colunas = [
            {
                Header: 'Código',
                accessor: 'codigo',
                width: 100,
                // eslint-disable-next-line
                filterMethod: (filter, row) => row[filter.id] == filter.value,
                Cell: (cellInfo) => <div className='text-align-center'>{produtos[cellInfo.index]['codigo']}</div>
            },
            {
                Header: 'Descrição',
                accessor: 'descricao',
                Cell: (cellInfo) => (
                    <div>
                        <If test={produtos[cellInfo.index]['novoProduto'] === 'S'}>
                            <Label size='tiny' color='green' horizontal content='Novo'/>
                        </If>
                        {produtos[cellInfo.index]['descricao']}
                    </div>
                )
            },
            {
                Header: 'Quantidade',
                accessor: 'quantidade',
                minWidth: 100,
                maxWidth: 200,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => {
                    const produto = produtos[cellInfo.index];

                    return (
                        <input 
                            contentEditable 
                            suppressContentEditableWarning
                            className='text-align-right editable-cell'
                            value={decimalFormat(produto['quantidade'], 3)}
                            onFocus={this.selectText}
                            onChange={({ target }) => {
                                const quantidade = decimalFormat(target.value, 3)
                                produto['quantidade'] = parseDecimal(quantidade, 3).toFixed(3);

                                this.calcularValorTotalProduto(cellInfo.index);
                            }}/>
                    );
                }
            },
            {
                Header: 'Valor unitário (R$)',
                accessor: 'valorMax',
                minWidth: 100,
                maxWidth: 200,
                show: LocalStorageManager.getLoggedUser().isCliente,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => <div className='text-align-right'>{decimalFormat(produtos[cellInfo.index]['valorMax'], 2)}</div>
            },
            {
                Header: 'Valor unitário (R$)',
                accessor: 'valorUnitario',
                minWidth: 100,
                maxWidth: 200,
                show: !LocalStorageManager.getLoggedUser().isCliente,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => {
                    const produto = produtos[cellInfo.index];
                    const valorLivre = produto['valorLivre'] === 'S';
                    const temComissao = produto['temComissao'] === 'S';
                    
                    const valorMax = parseDecimal(produto['valorMax'], 2);
                    const limiteDesconto = parseDecimal(produto['limiteDesconto'], 2);
                    const percentualComissao = parseDecimal(produto['percentualComissao'], 2);
                    
                    const descontoMax = temComissao ? limiteDesconto : parseFloat(limiteDesconto + percentualComissao);
                    const valorMin = valorMax - (valorMax * descontoMax / 100);
                    
                    return (
                        <Popup inverted position='top right' 
                            content={
                                valorLivre ? (
                                    <div><Icon name='warning circle' /> Valor do produto é livre.</div>
                                ) : (
                                    <div>
                                        <p>Max.: {decimalFormat(valorMax.toFixed(2), 2)}</p>
                                        <p>Min.: {decimalFormat(valorMin.toFixed(2), 2)}</p>
                                    </div>
                                )
                            }
                            trigger={
                                <input 
                                    contentEditable 
                                    suppressContentEditableWarning 
                                    className='text-align-right editable-cell'
                                    value={decimalFormat(produto['valorUnitario'], 2)}
                                    onFocus={this.selectText}
                                    onChange={({ target }) => {
                                        const valorUnitario = decimalFormat(target.value, 2)
                                        produto['valorUnitario'] = parseDecimal(valorUnitario, 2).toFixed(2);
        
                                        this.calcularValorTotalProduto(cellInfo.index);
                                    }}
                                    onBlur={({ target }) => {
                                        let valorUnitario = parseDecimal(target.value, 2);

                                        // Somente restringe o valor do produto se
                                        // o parametro de `valorLivre` estiver desativado
                                        if(!valorLivre) {
                                            // Mantem o valor unitario entre 
                                            // o `valorMin` e o `valorMax`.
                                            if(valorUnitario > valorMax) {
                                                valorUnitario = valorMax;
                                            } else if(valorUnitario < valorMin) {
                                                valorUnitario = valorMin;
                                            }
        
                                            const diferenca = valorUnitario - valorMax;
                                            const desconto = diferenca / valorMax * 100;
                                            produto['percentualDesconto'] = desconto.toFixed(2);
                                        }

                                        produto['valorUnitario'] = valorUnitario.toFixed(2);
                                        this.calcularValorTotalProduto(cellInfo.index);
                                    }}/>
                            }/>
                    )
                }
            },
            {
                Header: 'Desconto (%)',
                accessor: 'percentualDesconto',
                minWidth: 100,
                maxWidth: 200,
                show: !LocalStorageManager.getLoggedUser().isCliente,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => {
                    const produto = produtos[cellInfo.index];
                    const valorLivre = produto['valorLivre'] === 'S';
                    const temComissao = produto['temComissao'] === 'S';
                    
                    const percentualComissao = parseDecimal(produto['percentualComissao'], 2);
                    const limiteDesconto = parseDecimal(produto['limiteDesconto'], 2);
                    const descontoMax = temComissao ? limiteDesconto : parseFloat(limiteDesconto + percentualComissao);
                    
                    // Se for `valorLivre`, exibe somente
                    // um input desabilitado.
                    return valorLivre ? (
                        <input 
                            disabled 
                            className='text-align-right editable-cell'
                            value={decimalFormat(produto['percentualDesconto'], 2)} />
                    ) : (
                        <Popup inverted position='top right'
                            content={'Max.: ' + decimalFormat(descontoMax.toFixed(2), 2) + '%'}
                            trigger={
                                <input 
                                    disabled
                                    contentEditable 
                                    suppressContentEditableWarning 
                                    className='text-align-right editable-cell'
                                    value={decimalFormat(produto['percentualDesconto'], 2)}
                                    onFocus={this.selectText}
                                    onChange={({ target }) => {
                                        let percentualDesconto = parseDecimal(target.value, 2);

                                        if(percentualDesconto > descontoMax){
                                            percentualDesconto = descontoMax;
                                        }

                                        produto['percentualDesconto'] = percentualDesconto.toFixed(2);
                                        this.calcularValorTotalProduto(cellInfo.index);
                                    }}
                                    onBlur={({ target }) => {
                                        const valorMax = parseDecimal(produto['valorMax'], 2);
                                        const percentualDesconto = parseDecimal(produto['percentualDesconto'], 2);
                                        const valorUnitario = valorMax - (valorMax * percentualDesconto / 100);
                                        
                                        produto['valorUnitario'] = valorUnitario.toFixed(2);
                                        this.calcularValorTotalProduto(cellInfo.index);
                                    }}/>
                            }/>
                    );
                }
            },
            {
                Header: 'Comissão',
                accessor: 'temComissao',
                maxWidth: 100,
                show: !LocalStorageManager.getLoggedUser().isCliente,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => {
                    const produto = produtos[cellInfo.index];
                    const temComissao = produto['temComissao'];
                    
                    return (
                        <div className='text-align-center'>
                            <Popup inverted wide position='top center' size='mini' 
                                content={<div><Icon name='warning circle' /> Desabilitar a comissão aumenta o limite de desconto</div>}
                                trigger={
                                    <Checkbox toggle checked={temComissao === 'S'} onChange={() => {
                                        produto['temComissao'] = temComissao === 'S' ? 'N' : 'S';

                                        const percentualComissao = parseDecimal(produto['percentualComissao'], 2);
                                        const limiteDesconto = parseDecimal(produto['limiteDesconto'], 2);
                                        const descontoMax = produto['temComissao'] === 'S' ? limiteDesconto : parseFloat(limiteDesconto + percentualComissao);
                                        
                                        let percentualDesconto = parseDecimal(produto['percentualDesconto'], 2);

                                        if(percentualDesconto > descontoMax){
                                            const valorMax = parseDecimal(produto['valorMax'], 2);

                                            produto['percentualDesconto'] = descontoMax.toFixed(2);
                                            produto['valorUnitario'] = valorMax - (valorMax * descontoMax / 100);
                                        }

                                        this.calcularValorTotalProduto(cellInfo.index);
                                    }} />
                                }/>
                        </div>
                    );
                }
            },
            {
                Header: 'Valor total (R$)',
                accessor: 'valorTotal',
                minWidth: 100,
                maxWidth: 200,
                Filter: ({ filter, onChange }) => null,
                Cell: (cellInfo) => {
                    const valorTotal = decimalFormat(produtos[cellInfo.index]['valorTotal'], 2);
                
                    return <div className='text-align-right'><b>{valorTotal}</b></div>
                },
                Footer: (
                    <div>
                        <strong>Valor total: </strong>
                        <div className='float-right'>
                            <b>R$ { decimalFormat(_.sum(_.map(produtos, d => parseDecimal(d.valorTotal, 2))).toFixed(2), 2) }</b>
                        </div>
                    </div>
                )
            }
        ];

        return (
            <div>
                <Segment vertical clearing className='no-padding'>
                    <Button primary={!disabled} disabled={disabled} content='Adicionar produtos' icon='plus' floated='right' size='medium' type='button' className='vertical-align-bottom' onClick={this.abrirModalProdutos} />
                </Segment>

				<Modal open={adicionandoProdutos} size='fullscreen'>
					<Modal.Content>
						<Header>Adicionar produtos</Header>
                        <ReactTable data={produtos}
                                    columns={colunas} 
                                    loading={isLoading}
                                    showPagination={true}
                                    showPageSizeOptions={false}
                                    defaultPageSize={8}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]).toLocaleLowerCase().includes(filter.value.toString().toLocaleLowerCase())
                                    }
                                    style={{
                                        height: "65vh" // Limita o tamanho da tabela, forçando o scroll
                                    }}
                                    previousText='Pág. anterior'
                                    nextText='Próxima pág.'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum produto encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    className='-striped -highlight'/>
					</Modal.Content>
					<Modal.Actions>
						<Button secondary floated='left' icon='remove' content='Cancelar' onClick={() => this.setState({ adicionandoProdutos: false })}/>
						<Button positive icon='download' content='Salvar' onClick={this.salvarProdutos}/>
					</Modal.Actions>
				</Modal>
            </div>
        )
    }
}

export default ModalProdutos;


// WEBPACK FOOTER //
// ./src/views/OrcamentoVenda/ModalProdutos.js